import { appReducers } from 'store/lazyReducers'
import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import Dashboard from './Dashboard'
import GuestRoute from './Guest'
import SinglePageRoute from './SinglePage'
import JoinMeetingRoute from './JoinMeeting'

export const routes = (store) => [
  {
    component: createLazyRouteComponent({
      store,
      reducers: appReducers,
      loadComponent: () => import('./AppContainer'),
    }),
    routes: [
      GuestRoute(store),
      ...SinglePageRoute(store),
      JoinMeetingRoute(store),
      Dashboard(store),
    ],
  },
]

export default routes
